import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import {
  AdditionalInfo,
  LinkWrapper,
  StyledLabel,
  StyledLink,
  StyledNavigation,
} from './styled';
import { Label } from '../typography';
import { NavigationAndActionSuccessSmall } from '../icons';
import { NavigationType } from './NavigationType';
import { NavigationTab } from './NavigationTab';

export interface NavigationProps {
  activeTab: string;
  title?: string;
  options: NavigationTab[];
  type: NavigationType;
  infoText?: string;
  icon?: boolean;
  className?: string;
}

export const Navigation: React.FC<NavigationProps> = ({
  activeTab,
  options,
  title,
  type,
  infoText,
  icon,
  className,
}) => {
  const activeOption = useMemo(
    () => options.find((option) => option.url.includes(activeTab))?.label ?? '',
    [options, activeTab],
  );

  return (
    <StyledNavigation type={type} className={className}>
      {title && <StyledLabel type={type}>{title}</StyledLabel>}
      {options.map((option, index) => (
        <LinkWrapper key={option.label} type={type}>
          <Link to={option.url}>
            <StyledLink active={activeOption === option.label} type={type}>
              {option.label}
              {type === NavigationType.Tabs && infoText && (
                <AdditionalInfo icon={icon}>
                  <NavigationAndActionSuccessSmall />
                  <Label>{infoText}</Label>
                </AdditionalInfo>
              )}
            </StyledLink>
          </Link>
        </LinkWrapper>
      ))}
    </StyledNavigation>
  );
};
